module.exports = __webpack_public_path__ + "img/conny-stage6-hungry.a2994b79.png";